var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHelpWhiteCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.118,
    height: 31.117,
    viewBox: "0 0 31.118 31.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M14.479,0A14.559,14.559,0,1,0,29.117,14.479,14.558,14.558,0,0,0,14.479,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M9.209,9.086a8.8,8.8,0,0,1,2.484-1.408,7.767,7.767,0,0,1,2.7-.507,6.456,6.456,0,0,1,1.952.291,4.749,4.749,0,0,1,1.61.844,4.1,4.1,0,0,1,1.086,1.343,3.933,3.933,0,0,1,.4,1.8,3.991,3.991,0,0,1-.851,2.524A7.058,7.058,0,0,1,15.934,15.9l-1.267.592-.4,2.431h-1.3l-.239-1.455c-.031-.224-.058-.433-.079-.623a4.034,4.034,0,0,1-.035-.448,1.01,1.01,0,0,1,.154-.611,2.406,2.406,0,0,1,.644-.5l.786-.452c.5-.287.941-.55,1.32-.785a5.28,5.28,0,0,0,.946-.731,2.578,2.578,0,0,0,.558-.81,2.543,2.543,0,0,0,.182-1,2.149,2.149,0,0,0-.825-1.83,3.383,3.383,0,0,0-2.092-.623,5.836,5.836,0,0,0-1.35.162,14.457,14.457,0,0,0-1.726.572l-1.334.5ZM12.5,22.871V20.8h1.766a.611.611,0,0,1,.377.079.366.366,0,0,1,.091.287v1.705Z",
    transform: "translate(0.233 -0.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 29.117,
    height: 29.117,
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpWhiteCircle);
export default __webpack_public_path__ + "static/media/icon_help_white_circle.3c683d96a856c6c32d0cd662c714ba74.svg";
export { ForwardRef as ReactComponent };